import { api, ApiRequestConfig } from './api';
import i18n from 'i18next';

interface IVerificationCodeVerify {
  phoneNumber: string;
  verificationCode: string;
  regionId: string;
}

interface IVerificationCodeVerifyResponse {
  error?: boolean;
  message?: string | null;
}

export const verificationCodeVerify = async (
  params: IVerificationCodeVerify,
  config: ApiRequestConfig,
): Promise<IVerificationCodeVerifyResponse> => {
  try {
    await api.post(
      'loyalty-registration-modal/verification-code-verify',
      {
        phoneNumber: params.phoneNumber,
        verificationCode: params.verificationCode,
        regionId: params.regionId,
      },
      config,
    );

    return {
      error: false,
      message: null,
    };
  } catch (e) {
    const error = e as Error;

    let message = i18n.t('loyalty-registration-modal.verify-code-step.errors.internal');

    if (error.message?.includes('incorrect')) {
      message = i18n.t('loyalty-registration-modal.verify-code-step.errors.incorrect');
    }

    if (error.message?.includes('expired')) {
      message = i18n.t('loyalty-registration-modal.verify-code-step.errors.expired');
    }

    return {
      error: true,
      message,
    };
  }
};
